module.exports = __webpack_public_path__ + "img/promotional_activities.c2f8de62.png";